import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Link from 'react-router-dom/Link';
import Typography from '@material-ui/core/Typography';
import logo from '../../assets/images/beneficios.svg';

const propTypes = {
  isOpen: PropTypes.bool.isRequired,
};

const useStyles = makeStyles(theme => ({
  menuHeaderTitle: {
    fontSize: 0,
    height: 56,
    padding: theme.spacing(1, 2),
    marginBottom: 24,
  },
  menuHeaderLink: {
    color: 'inherit',
    display: 'inline-block',
    fontWeight: 700,
    fontSize: 40,
    lineHeight: 0,
    textDecoration: 'none',
  },
  figure: {
    margin: 0,
    width: 152,
    transition: theme.transitions.create('all', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  figureCollapsed: {
    margin: 0,
    overflow: 'hidden',
    width: 29,
    transition: theme.transitions.create('all', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  menuHeaderLogo: {
    height: 40,
    objectFit: 'contain',
    width: 152,
  },
}));

function Header(props) {
  const classes = useStyles();
  const { isOpen } = props;
  const titleProps = {
    color: 'inherit',
    className: classes.menuHeaderTitle,
    variant: 'h1',
  };

  return (
    <Typography {...titleProps}>
      <Link className={classes.menuHeaderLink} to="/">
        <figure
          className={clsx({
            [classes.figure]: isOpen,
            [classes.figureCollapsed]: !isOpen,
          })}
        >
          <img
            className={classes.menuHeaderLogo}
            src={logo}
            alt="BCP"
          />
        </figure>
      </Link>
    </Typography>
  );
}

Header.propTypes = propTypes;

export default Header;
